exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".box {\r\n    background: #d0caca;\r\n    padding: 2px 8px;\r\n    margin-right: 20px;\r\n    border-radius: 2px;\r\n    border: 1px solid;\r\n}\r\n.checkbox-inline {\r\n    padding: 0px;\r\n}\r\n.box.red {\r\n    background-color: var(--main-danger)\r\n}\r\n.box.blue {\r\n    background-color: var(--main-info)\r\n}\r\n.box.green {\r\n    background-color: var(--main-success)\r\n}\r\n.box.orange {\r\n    background-color: var(--main-warning)\r\n}\r\n.box.brown {\r\n    background-color: var(--main-brown)\r\n}\r\n.incluir {\r\n    padding: 5px 10px;\r\n    background: #eeeeee;\r\n    border-radius: 3px;\r\n    color: #212529;\r\n}\r\n.panel-heading .input-group-addon {\r\n    color: #212529;\r\n}\r\ntable {\r\n    font-size: 14px;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/AINSA WEB/Documents/proyects/ROUTEMEE/routemee-web-application/src/app/components/reportes/data-credito/data-credito.component.css
// module id = ../../../../../src/app/components/reportes/data-credito/data-credito.component.css
// module chunks = main